module.exports = __webpack_public_path__ + "static/media/tigger_soundi_visoki_2.e5b509ae.mp3";